"use strict";
/**
 * Cursor pagination.
 *
 * O cursor é um payload base64url opaco — o cliente não deve interpretá-lo, e
 * ele não revela offsets nem IDs sequenciais.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeCursor = encodeCursor;
exports.decodeCursor = decodeCursor;
exports.clampLimit = clampLimit;
exports.buildPage = buildPage;
const config_1 = require("@nossorachao/config");
function toBase64Url(input) {
    const base64 = typeof Buffer !== 'undefined'
        ? Buffer.from(input, 'utf8').toString('base64')
        : btoa(unescape(encodeURIComponent(input)));
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function fromBase64Url(input) {
    const base64 = input.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    return typeof Buffer !== 'undefined'
        ? Buffer.from(padded, 'base64').toString('utf8')
        : decodeURIComponent(escape(atob(padded)));
}
function encodeCursor(payload) {
    return toBase64Url(JSON.stringify(payload));
}
/** Retorna null em cursor malformado — nunca lança para um input de cliente. */
function decodeCursor(cursor) {
    if (!cursor)
        return null;
    try {
        const parsed = JSON.parse(fromBase64Url(cursor));
        if (typeof parsed.k !== 'string' || typeof parsed.i !== 'string')
            return null;
        return { k: parsed.k, i: parsed.i };
    }
    catch {
        return null;
    }
}
function clampLimit(limit) {
    if (!limit || !Number.isFinite(limit) || limit < 1)
        return config_1.PAGINATION.DEFAULT_LIMIT;
    return Math.min(Math.floor(limit), config_1.PAGINATION.MAX_LIMIT);
}
/**
 * Monta o envelope paginado a partir de `limit + 1` registros buscados:
 * o item extra indica que existe próxima página e não é devolvido.
 */
function buildPage(rows, limit, cursorOf) {
    const hasMore = rows.length > limit;
    const data = hasMore ? rows.slice(0, limit) : rows;
    const last = data[data.length - 1];
    return {
        data,
        meta: {
            nextCursor: hasMore && last ? encodeCursor(cursorOf(last)) : null,
            hasMore,
            limit,
        },
    };
}
//# sourceMappingURL=pagination.js.map